import React from "react";

const DeferredAttachmentSection = ({
  label = "Select File (PDF / JPG / PNG)",
  accept = ".pdf,.jpg,.jpeg,.png",
  multiple = true,
  disabled = false,
  pendingFiles = [],
  uploadedFiles = [],
  onSelectFiles,
  onRemovePendingFile,
  onDeleteUploadedFile,
  getUploadedFileKey,
  getUploadedFileName,
  getUploadedFileUrl,
  getUploadedFileMeta,
  deletingFileId = null,
  pendingTitle = "Files Ready To Save",
  uploadedTitle = "Uploaded Files",
}) => {
  return (
    <>
      <div className="mb-3">
        <label>{label}</label>
        <input
          type="file"
          className="form-control"
          accept={accept}
          multiple={multiple}
          disabled={disabled}
          onChange={onSelectFiles}
        />
      </div>

      {pendingFiles.length > 0 && (
        <div className="mt-4 p-3 bg-light rounded border">
          <div className="text-muted mb-2">{pendingTitle}</div>
          <ul className="list-unstyled mb-0">
            {pendingFiles.map((pendingFile, idx) => (
              <li
                key={`${pendingFile.name}_${pendingFile.size}_${pendingFile.lastModified}_${idx}`}
                className="d-flex justify-content-between align-items-center py-1"
              >
                <span>{pendingFile.name}</span>
                <button
                  type="button"
                  className="btn btn-sm btn-outline-danger"
                  onClick={() => onRemovePendingFile?.(pendingFile)}
                  disabled={disabled}
                  title="Delete"
                >
                  <i className="bi bi-trash"></i>
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}

      {uploadedFiles.length > 0 && (
        <div className="mt-4 p-3 bg-light rounded border">
          <div className="text-muted mb-2">{uploadedTitle}</div>

          <ul className="list-unstyled mb-0">
            {uploadedFiles.map((file) => {
              const fileKey = getUploadedFileKey(file);
              const fileMeta = getUploadedFileMeta?.(file);

              return (
                <li
                  key={fileKey}
                  className="d-flex justify-content-between align-items-center py-1"
                >
                  <div>
                    <a
                      href={getUploadedFileUrl(file)}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {getUploadedFileName(file)}
                    </a>
                    {fileMeta && <div className="text-muted">{fileMeta}</div>}
                  </div>

                  {onDeleteUploadedFile && (
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-danger"
                      onClick={() => onDeleteUploadedFile(file)}
                      disabled={disabled || deletingFileId === fileKey}
                      title="Delete"
                    >
                      {deletingFileId === fileKey ? (
                        "Deleting..."
                      ) : (
                        <i className="bi bi-trash"></i>
                      )}
                    </button>
                  )}
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </>
  );
};

export default DeferredAttachmentSection;
